// extracted by mini-css-extract-plugin
export default {"card_container":"Skeleton_card_container__O5LvQ"};